import { BasicEntity, CatalogGridItem, Group } from '@/types/Catalogs'

export class ProjectCatalogGridItem extends CatalogGridItem {
  name: string
  domain: BasicEntity
  enable: string
  groups: string
  creationDate: string
  updateDate: string
}

export class Project {
  id: number
  name: string
  domain: BasicEntity
  enable: boolean
  // Automatic fields
  creationDate: Date
  creationUser: {
    id: number,
    name: string
  }
  updateDate: Date
  updateUser: {
    id: number,
    name: string
  }
  groups: Group[]

  static getInstanceForEdit () {
    const instance = new Project()
    instance.name = ''
    instance.domain = new BasicEntity(-1, '')
    instance.enable = true
    instance.groups = []
    return instance
  }
}

export class ProjectCatalogFilters {
  enable: boolean | undefined = undefined
  enableSelect : boolean[]
  considerSubgroups : boolean
  status = [
    { value: true, text: 'Sí' },
    { value: false, text: 'No' }
  ]
  group: number
  deepSearch: boolean
  domain: number
  loadRelations: boolean
}
